import React from 'react';
import Localize from 'react-intl-universal';

import useEmblaCarousel from 'embla-carousel-react';

import Button from '@mui/material/Button';
import { styled, useTheme } from '@mui/material/styles';

import { PrevButton, NextButton, usePrevNextButtons } from './EmblaCarouselArrowButtons.jsx';
import {
  SelectedSnapDisplay,
  useSelectedSnapDisplay
} from './EmblaCarouselSelectedSnapDisplay.jsx';
import './embla.css';

const StyledButton = styled(Button)(({ theme }) => ({
  color: theme.palette.common.white,
  fontSize: '11px'
}));

const EmblaCarousel = (props) => {
  const { slides, options, onClickAdditionalBtn = () => {}, isAdditionalBtn = false } = props;
  const [emblaRef, emblaApi] = useEmblaCarousel(options);
  const theme = useTheme();

  const { prevBtnDisabled, nextBtnDisabled, onPrevButtonClick, onNextButtonClick } =
    usePrevNextButtons(emblaApi);

  const { selectedSnap, snapCount } = useSelectedSnapDisplay(emblaApi);

  return (
    <section className='embla'>
      <div className='embla__viewport' ref={emblaRef}>
        <div className='embla__container'>
          {slides.map((slide, index) => (
            <div className='embla__slide' key={index}>
              <div className='embla__slide__number'>{slide}</div>
            </div>
          ))}
        </div>
      </div>

      <div className='embla__controls'>
        <div className='embla__buttons'>
          {isAdditionalBtn && (
            <StyledButton onClick={onClickAdditionalBtn}>
              {Localize.get('HomePage.readAll')}
            </StyledButton>
          )}
          <PrevButton
            onClick={onPrevButtonClick}
            currentColor={theme.palette.common.white}
            disabled={prevBtnDisabled}
          />
          {slides.length > 3 && (
            <SelectedSnapDisplay selectedSnap={selectedSnap} snapCount={snapCount} />
          )}
          <NextButton
            onClick={onNextButtonClick}
            currentColor={theme.palette.common.white}
            disabled={nextBtnDisabled}
          />
        </div>
      </div>
    </section>
  );
};

export default EmblaCarousel;
